import { Controller } from "@hotwired/stimulus"

// При возврате на ленту через "назад" принудительно обновляем страницу
// морфингом, чтобы счётчики реакций/комментариев актуализировались
// без потери скролла и подгруженных страниц.
export default class extends Controller {
  connect() {
    // window.performance.navigation.type === 2 означает навигацию "назад/вперёд"
    if (window.performance?.navigation?.type === 2 && window.Turbo?.visit) {
      window.Turbo.visit(window.location.href, { action: "replace" })
    }
  }
}
